import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Geolocation } from '@ionic-native/geolocation/ngx';
// import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
// import { IonicStorageModule } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppEnum } from 'src/app/appenum';
import { sessionInterceptor } from './services/session.interceptor';
import { ThemingService } from './services/theming.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateService } from './services/custom-translate.service';
import { AppSettings } from './app.settings';

import { SharedModule } from './shared/shared.module';
import { AppService } from 'src/app/services/app.service';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicStorageModule.forRoot(),
        IonicModule.forRoot(),
        SharedModule,
        // BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateService,
            }, isolate: false, extend: true
        }),
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        Title,
        Storage,
        AppEnum,
        AppSettings,
        AppService,
        { provide: HTTP_INTERCEPTORS, useClass: sessionInterceptor, multi: true },
        Geolocation, { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: APP_INITIALIZER,
            // Provide the APP_INITIALIZER, wait until the theming configuration is fetched and set up correctly
            useFactory: (themingService: ThemingService) => () => themingService.initialize(),
            deps: [ThemingService],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
